export default JSON.parse(`{
  "inviter": {
    "country": "PL"
  },
  "isLoggedInUserMaster": false,
  "planHoppingRestrictionsApply": false,
  "joinRestrictions": [],
  "homeId": "21f7a247-cdf3-4f17-b058-fe4c5b41d5ee"
}`);
